import { Grid, makeStyles, Tooltip, Typography, useTheme } from '@material-ui/core';
import { CardRevendaRespostaPropagandaProps } from './card-revenda-resposta-propaganda-props';
import { DefaultCard } from '../components/default-card';
import { useCallback } from 'react';
import { EnumSituacaoPessoa } from 'model/enums/enum-situacao-pessoa';
import { useThemeQueries } from 'views/theme';

const useStyles = makeStyles((theme) => (
  {
    cardRightButton: {
      width: "50px",
      borderLeftWidth: 1,
      borderLeftStyle: "solid",
      borderLeftColor: theme.palette.divider,
      margin: '0px 0px 0px 10px',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
      "& svg": {
        margin: 0,
        width: "22px",
        height: "22px",
        fill: theme.palette.primary.main,
      },
    },
    container: {
      padding: theme.spacing(2),
      "& .MuiTypography-body1": {
        fontSize: 12
      }
    }
  }
))

export const CardRevendaRespostaPropaganda = ({
  model,
  onClick,
  onCheck,
  selected,
}: CardRevendaRespostaPropagandaProps) => {
  const { palette } = useTheme()
  const { isMobile } = useThemeQueries()

  const classes = useStyles()

  const statusColor = useCallback(() => {
    switch (model.status) {
      case 0:
        return palette.success.main
      case 1:
        return palette.error.main
      case 2:
        return palette.warning.main
    }
  }, [model.status, palette.error.main, palette.success.main, palette.warning.main])

  return (
    <>
      <DefaultCard
        isSelected={selected}
        onClick={() => {
          onClick(model);
        }}
      >
        <Tooltip title={EnumSituacaoPessoa[model.status]} placement='right'>
          <div style={{
            backgroundColor: statusColor(),
            width: '5px',
            borderRadius: '5px',
            alignSelf: 'stretch',
            margin: '7px'
          }} />
        </Tooltip>
        <Grid container spacing={1} className={classes.container} alignItems='center'>
          <Grid item xs={12} md={6} lg={6}>
            <Typography
              color="textPrimary"
              variant="body1"
            >
              <b>{model.nomeComercial}</b>
            </Typography>
          </Grid>
          {model.revendaId && <Grid item xs={6} md={6} lg={6}>
          </Grid>}
          {!isMobile && <Grid md={6} xs={6} lg={model.revendaId ? 1 : 2}>
            <Typography color='textPrimary' variant='caption'>
              Telefone
            </Typography>
            <Typography color='textPrimary' variant='body1'>
              {!model.informacoes || !model.informacoes.telefone ? '-' : model.informacoes.telefone}
            </Typography>
          </Grid>}
        </Grid>
      </DefaultCard>
    </>
  );
};
